export function convertirFecha(fechaStr) {
  // Convierte la cadena de texto a un objeto Date
  const fecha = new Date(fechaStr);

 
  const año = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0'); 
  const dia = String(fecha.getDate()).padStart(2, '0');


  const fechaFormateada = `${año}-${mes}-${dia}`;

  return fechaFormateada;
}